module.exports = __webpack_public_path__ + "img/security.83aa670f.svg";